import { Box, Typography } from "@mui/material";
import { colors } from "./ThemeRegistry/theme";
import { memo } from "react";

const DiffInheritanceIndicator = ({
    marginLeft,
}: Readonly<{
    marginLeft?: number;
}>) => {
    return <Box maxWidth={0}>
        <Typography sx={{
            fontSize: "24px",
            color: colors.blue,
            ml: marginLeft ?? 1,
            position: "relative",
        }}>^</Typography>
    </Box>;
};

export default memo(DiffInheritanceIndicator);